import compu from './3937432.svg'
import IconoSomos from './ICONO_SOMOS1.svg'


export default {
    "compu": compu,
    "IconoSomos": IconoSomos
}